/* HLP Smart Cross-Sell Drawer — Safe display test V2.
   Only shows recommendations already configured on the Cart Page.
   The add controls are intentionally removed for this visibility test.
*/
(() => {
  'use strict';
  if (window.__hlpScsDrawerPreviewV2) return;
  window.__hlpScsDrawerPreviewV2 = true;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const getMount = () => document.querySelector('#CartDrawer #hlp-scs-drawer-mount');
  const isOpen = () => drawer.classList.contains('active');
  let previousMount = getMount();
  let wasOpen = isOpen();
  let timer;
  let requestId = 0;

  async function updateRecommendations() {
    const target = getMount();
    if (!target || !isOpen()) return;
    const request = ++requestId;

    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopRoot}cart`, {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error(`Cart HTTP ${response.status}`);

      const documentHTML = new DOMParser().parseFromString(
        await response.text(), 'text/html'
      );
      const panel = documentHTML.querySelector(
        '#MainContent [data-hlp-scs-root] .hlp-scs__panel'
      );
      if (request !== requestId || !target.isConnected) return;

      target.replaceChildren();
      if (!panel) {
        target.hidden = true;
        return;
      }

      // Read-only preview; the variant/add interactions come after this test.
      panel.querySelectorAll('.hlp-scs__actions').forEach((node) => node.remove());
      panel.querySelectorAll('[id]').forEach((node) => {
        node.id = `hlp-drawer-${node.id}`;
      });
      target.appendChild(panel);
      target.hidden = false;
    } catch (error) {
      console.warn('[HLP Drawer preview] Unable to load suggestions:', error);
    }
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateRecommendations, 150);
  }

  const observer = new MutationObserver(() => {
    const nextMount = getMount();
    const nowOpen = isOpen();
    if (nowOpen && (!wasOpen || nextMount !== previousMount)) {
      scheduleUpdate();
    }
    previousMount = nextMount;
    wasOpen = nowOpen;
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });
  if (isOpen()) scheduleUpdate();
})();
